import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "42",
  fill: "none",
  viewBox: "0 0 12 12"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6 2.434c-2.034 0-3.61 1.499-3.61 3.26 0 1.057.546 1.971 1.44 2.622.085.062.136.16.136.265v.863l1.05-.54a.33.33 0 0 1 .21-.033c.26.043.542.082.774.082 2.034 0 3.61-1.498 3.61-3.26 0-1.801-1.573-3.259-3.61-3.259m-.777 7.101A5 5 0 0 0 6 9.609c2.34 0 4.266-1.739 4.266-3.915 0-2.223-1.928-3.916-4.266-3.916-2.34 0-4.266 1.74-4.266 3.916 0 1.247.621 2.305 1.575 3.05v1.237a.328.328 0 0 0 .479.292z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.018 6.512a.33.33 0 0 1 .464 0 2.1 2.1 0 0 0 2.992 0 .328.328 0 0 1 .464.464 2.76 2.76 0 0 1-3.92 0 .33.33 0 0 1 0-.464M5.125 4.228c.181 0 .328.147.328.328v.438a.328.328 0 0 1-.656 0v-.438c0-.181.147-.328.328-.328M6.875 4.228c.181 0 .328.147.328.328v.438a.328.328 0 0 1-.656 0v-.438c0-.181.147-.328.328-.328",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }